import { HttpClient, HttpHeaders } from '@angular/common/http';
import {QrCodeRequest} from '../../models/qr-code-request.model';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {QrCodeResponse} from '../../models/qr-code-response';

@Injectable({
  providedIn: "root"
})

export class QrGenerationService {
  constructor(private readonly http: HttpClient) {
  }

  generateQR(qrCodeRequest: QrCodeRequest): Observable<QrCodeResponse> {
    const token = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    return this.http.post<QrCodeResponse>('api/qr', qrCodeRequest, { headers });
  }
}
